import React, { useCallback, useEffect, useState } from "react";
import StackedColumnChart from "../../CHARTS/StackedColumnChart";
import Loading from "../../Extra/Loading";
import { useGlobalContext } from "../../Context/GlobalContext";
import { getCurrentDate } from "../../Utilitie";
import SuggestionInput from "../../Extra/SuggestionInput";
import { HiMiniH1 } from "react-icons/hi2";

const PunctualityTrainDetentionCodeWise = () => {
  const { globalCurrentFY } = useGlobalContext();
  const [fyYear, setFyYear] = useState("");
  const [fyYearData, setFyYearData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [selectedSection, setSelectedSection] = useState(""); // Track selected section
  const [showingFyYear, setShowingFyYearData] = useState("");
  const [fData, setFData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [detentionCode, setDetentionCode] = useState([]);
  const [chartData, setChartData] = useState({ categories: [], series: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const currentDate = getCurrentDate();

  useEffect(() => {
    setFyYear(globalCurrentFY);
  }, [globalCurrentFY]);

  // Fetch Data Logic with Section Filter
  const fetchData = useCallback(async () => {
    if (!fyYear && (!fromDate || !toDate)) return;

    setLoading(true);
    setError(false);

    let url = `${process.env.REACT_APP_URL_PREFIX}pplosttraincountdetcodewise`;

    if (fromDate && toDate) {
      url += `?from_date=${fromDate}&to_date=${toDate}`;
    } else if (fyYear) {
      url += `?fin_yr_array=${fyYear}`;
    }

    if (selectedSection) {
      url += `&section=${selectedSection}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      if (data?.data?.length > 0) {
        setFData(data.data[0].data);
        setFyYearData(data?.financial_years || []);
        setShowingFyYearData(data?.data[0]?.fy || "");
        setSectionData(data?.section || []);

        // Extract unique detention codes
        const uniqueKeys = [
          ...new Set(
            data.data[0].data.flatMap((item) => Object.keys(item.data))
          ),
        ];
        setDetentionCode(uniqueKeys);
      } else {
        setChartData({ categories: [], series: [] });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [fyYear, fromDate, toDate, selectedSection]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //  Process Chart Data
  useEffect(() => {
    if (fData.length > 0 && detentionCode.length > 0) {
      processChartData();
    }
  }, [fData, detentionCode]);

  const processChartData = () => {
    const categories = fData.map((dataObj) => dataObj.train_no);
    const series = detentionCode.map((code) => ({
      name: code,
      data: fData.map((dataObj) => dataObj.data[code] || 0),
    }));

    setChartData({ categories, series });
  };
  //  Handle FY and Date Changes
  const handleFyYearChange = (e) => {
    const selectedFY = e.target.value;
    if (selectedFY !== fyYear) {
      setFyYear(selectedFY);
      setFromDate(null);
      setToDate(null);
    }
  };

  const handleDateChange = (e, type) => {
    if (type === "from") setFromDate(e.target.value);
    if (type === "to") setToDate(e.target.value);
    setFyYear("");
  };

  //  Reset FY when date range is used and vice versa
  useEffect(() => {
    if (fromDate && toDate) setFyYear(null);
  }, [fromDate, toDate]);

  useEffect(() => {
    if (fyYear) {
      setFromDate(null);
      setToDate(null);
    }
  }, [fyYear]);
  return (
    <div style={{ minHeight: "400px" }}>
      <div className="ps-1 pe-1 bg-dark text-white">
        <div className="d-flex justify-content-between">
          <div>
            <h6>Train/ Detention Code Punctuality</h6>
          </div>
          <div>Total Trains: {chartData.categories.length}</div>
        </div>

        <div className="row" style={{ fontSize: "12px" }}>
          <div className={`d-flex col-md-${fromDate && toDate ? "3" : "4"}`}>
            <label>FY:- </label>
            <select
              style={{ height: "23px", maxWidth: "150px" }}
              onChange={handleFyYearChange}
              value={fyYear || ""}
            >
              <option value="">Select FY</option>
              {fyYearData.map((fy, index) => (
                <option value={fy} key={index}>
                  {fy}
                </option>
              ))}
            </select>
          </div>

          <div className={`d-flex col-md-${fromDate && toDate ? "3" : "4"}`}>
            <label>From:-</label>
            <input
              style={{ height: "23px", maxWidth: "150px" }}
              type="date"
              value={fromDate || ""}
              onChange={(e) => handleDateChange(e, "from")}
              max={toDate || currentDate}
            />
          </div>

          <div className={`d-flex col-md-${fromDate && toDate ? "3" : "4"}`}>
            <label>To:-</label>
            <input
              style={{ height: "23px", maxWidth: "150px" }}
              type="date"
              value={toDate || ""}
              onChange={(e) => handleDateChange(e, "to")}
              min={fromDate || ""}
              max={currentDate}
            />
          </div>
          {fromDate && toDate ? (
            <div className={`col-md-${fromDate && toDate ? "3" : "4"}`}>
              <SuggestionInput
                data={sectionData}
                setSelectedSection={setSelectedSection}
                title={"section"}
              />
            </div>
          ) : null}
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : chartData.categories.length > 0 ? (
        <StackedColumnChart data={chartData} from={"trainDeTCode"} />
      ) : (
        <div>No Data Found</div>
      )}
    </div>
  );
};

export default PunctualityTrainDetentionCodeWise;
